import type {
  AccessGrantDiff,
  AccessResourceType,
} from '~/features/access-control/types/AccessControl';

import { ServiceRequestConfig } from '~/services/createService';
import { pilot } from '~/services/serviceInstances';

import type {
  ResourceAccess,
  ServerAccessGrant,
  ServerAccessPrincipalRef,
  ServerResourceAccess,
} from './accessGrantMapper';

import {
  mapGrantToServer,
  mapPrincipalToServerRef,
  mapResourceAccessResponse,
} from './accessGrantMapper';

type Request = {
  resourceId: string;
  resourceType: AccessResourceType;
} & AccessGrantDiff;

type ServerRequest = {
  resource_id: string;
  resource_type: AccessResourceType;
  inherit_from_parent: boolean;
  added_grants: ServerAccessGrant[];
  updated_grants: ServerAccessGrant[];
  removed_principals: ServerAccessPrincipalRef[];
};

export const updateResourceAccess = async (
  request: Request,
  options: ServiceRequestConfig = {},
): Promise<ResourceAccess> => {
  const serverResponse = await pilot.put<ServerResourceAccess>(
    '/access/resource/',
    mapRequest(request),
    options,
  );

  return mapResourceAccessResponse(serverResponse);
};

function mapRequest(request: Request): ServerRequest {
  return {
    resource_id: request.resourceId,
    resource_type: request.resourceType,
    inherit_from_parent: request.inheritFromParent,
    added_grants: request.addedGrants.map(mapGrantToServer),
    updated_grants: request.updatedGrants.map(mapGrantToServer),
    removed_principals: request.removedPrincipals.map(mapPrincipalToServerRef),
  };
}
